import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications } from '../helpers';
import { DeleteShowDocument } from './delete.generated';

export const useDeleteShow = () => {
  const { t } = useTranslation();

  return useMutation(DeleteShowDocument, {
    ...useNotifications(DeleteShowDocument, {
      failure: t('api.common.error_generic'),
      success: (data) => {
        const count = data.deleteShow?.deletedIds.length ?? 0;
        return t('api.shows.delete_success_plural', { count });
      },
    }),
    update(cache, { data }) {
      if (!data?.deleteShow?.deletedIds.length) return;
      data.deleteShow.deletedIds.forEach((id) => cache.evict({ id: `Show:${id}` }));
    },
  });
};
